<div class="fiche-section">
  <div class="fiche-section-title">
    Documents
    @if (documents.length) {
      <span class="ml-1.5 px-1.5 py-0.5 rounded-full text-[10px] bg-primary-100 text-primary-700">{{ documents.length }}</span>
    }
  </div>

  @if (!documents.length) {
    <div class="flex flex-col items-center justify-center py-12 text-stone-400">
      <div class="w-14 h-14 rounded-3xl bg-stone-100 flex items-center justify-center mb-3">
        <svg class="w-6 h-6 text-stone-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
        </svg>
      </div>
      <p class="text-sm font-medium">Aucun document joint</p>
    </div>
  } @else {
    <div class="fiche-section-box">
      <div class="space-y-4">
        @for (group of groupedDocs(); track $index) {
          <div class="p-4 bg-stone-50 rounded-lg border border-stone-200">
            <div class="flex items-start justify-between gap-3 mb-3">
              <div class="flex-1 min-w-0">
                <div class="flex items-center gap-2">
                  <p class="text-sm font-medium text-stone-700">{{ group.document_name_fr || group.document_type || 'Document' }}</p>
                  @if (group.files.length > 1) {
                    <span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-semibold bg-primary-100 text-primary-700">{{ group.files.length }} fichiers</span>
                  }
                </div>
                @if (group.document_name_ar) {
                  <p class="text-xs text-stone-400 mt-0.5 text-right" dir="rtl">{{ group.document_name_ar }}</p>
                }
              </div>
            </div>
            <div class="space-y-2">
              @for (file of group.files; track $index) {
                <div class="flex items-center justify-between gap-3 pl-3 border-l-2 border-stone-200">
                  <span class="text-xs text-stone-400 truncate">{{ file.file_name }}</span>
                  <div class="flex items-center gap-2 flex-shrink-0">
                    @if (file.serve_url || file.file_link) {
                      <button (click)="onView(file)" type="button"
                        class="px-3 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors">Voir</button>
                      <button (click)="onDownload(file)" type="button"
                        class="px-3 py-1 text-xs bg-primary-600 text-white rounded hover:bg-primary-700 transition-colors">Télécharger</button>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
